import api from "@/lib/api";

export const MEDIA_TYPES = ["image/jpeg", "image/png", "image/webp", "video/mp4", "video/webm"];
export const validMedia = (file) => MEDIA_TYPES.includes(file.type) && file.size > 0 && file.size <= (file.type.startsWith("image/") ? 10 : 50) * 1024 * 1024;

export async function uploadMedia(item, signal, update) {
  let upload = item.upload;
  if (!upload) {
    const { data } = await api.post("/media/uploads", { filename: item.file.name, size: item.file.size, content_type: item.file.type }, { signal });
    upload = data;
    update({ upload });
  }
  if (item.ready) return upload.id;
  for (let index = item.nextChunk || 0; index < upload.chunks; index++) {
    const start = index * upload.chunk_size;
    const chunk = item.file.slice(start, start + upload.chunk_size);
    await api.put(`/media/uploads/${upload.id}/chunks/${index}`, chunk, {
      signal, headers: { "Content-Type": "application/octet-stream" },
      onUploadProgress: (event) => update({ progress: Math.min(99, Math.round((start + event.loaded) / item.file.size * 100)) }),
    });
    update({ nextChunk: index + 1 });
  }
  update({ processing: true });
  await api.post(`/media/uploads/${upload.id}/complete`, {}, { signal });
  update({ progress: 100, ready: true, processing: false });
  return upload.id;
}